module.exports = __webpack_public_path__ + "img/40_38_059_290.c9217183.jpg";